<template>
	<div class="container extend-page">
		<!-- 头部导航 -->
		<header-bar name='待审陪诊人' />

    <!-- 无数据 -->
    <empty text='目前暂无待审陪诊人' v-if="arrEmployee.length == 0" />

		<div class="list">
			<div class="item" 
			v-for="(item, index) in arrEmployee" 
			:key='index'>
				<div class="text">
					<div class="name" :class="item.sex == 0 ? 'name-male' : 'name-female'">{{item.name}}</div>
					<div class="age">{{ item.age }}</div>
				</div>
				<div class="info">
					<div class="row">
						<div class="lab">手机</div>
						<div class="inf">{{item.phone}}</div>
					</div>
					<div class="row">
						<div class="lab">居住地</div>
						<div class="inf">{{item.address}}</div>
					</div>
					<div class="row">
						<div class="lab">有无驾照</div>
						<div class="inf">{{ item.drivingLicense == 1 ? '有' : '没有' }}</div>
					</div>
				</div>
				<div class="link">
					<div class="lnk-item lnk-default" :data-id='item.id' @click="handlerMemberDetail">查看</div>
					<div class="lnk-item lnk-ok" :data-id='item.id' :data-phone='item.phone' @click="handlerDo">通过</div>
					<div class="lnk-item lnk-no" :data-id='item.id' :data-name='item.name' :data-phone='item.phone' @click="handlerClose">拒绝</div>
				</div>
			</div>
		</div>

    <van-overlay :show="flagModels">
      <div class="model-box">
        <div class="hd">
          <div class="name">拒绝</div>
          <div class="link" @click="flagModels = false"><img class="ico" src="~assets/images/icon-close.png" /></div>
        </div>
        <div class="bd">
          <div class="area">
            <div class="lab required">请输入拒绝原因</div>
            <div class="txt">
              <textarea class="text" v-model="refuseReason"></textarea>
            </div>
          </div>
        </div>
        <div class="ft">
          <div class="link" @click="handlerSaveTask">提交</div>
        </div>
      </div>
    </van-overlay>

    <!-- 触底 -->
    <loading-more
      v-show="isLoading && !isHadMore && arrEmployee.length > 0"
      @doLoading="initList"
      :isNoData="isHadMore"
      :isLoading="isLoading"
    />
	</div>
</template>

<script>
	import HeaderBar from 'components/HeaderBar/HeaderBar'
  import LoadingMore from "@/components/LoadingMore/LoadingMore"
  import Empty from 'components/Empty/Empty'
  import { attendantList, attendantAudit, sendSms } from "@/api/home";
  import {passportUserInfo} from "@/api/login";
  import axios from "axios";
	export default{
		name: 'MemberList',
		components: {
			HeaderBar,
      LoadingMore,
      Empty
		},
		data() {
			return {
				arrEmployee: [],
        isLoading: false,
        isHadMore: true,
        pageNumber: 1,
        pages: 999,
        flagModels: false,
        refuseId: '',
        refuseReason: '',
        name:'',
        phone:'',
        preventRepeatRequest: false, //到达底部加载数据，防止重复加载
			}
		},
		methods: {
			// 跳转详情
			handlerMemberDetail: function(e){
				// let eId = parseInt(e.currentTarget.dataset.id) //精度丢失
				let eId = e.currentTarget.dataset.id;
				this.$router.push({
					path: '/member-detail',
					query: {
						id: eId
					}
				})
			},

      //通过
      handlerDo: function (e) {
        let eCode = e.currentTarget.dataset.id
        let phone = e.currentTarget.dataset.phone
        this.$dialog.confirm({
          title: '系统提示',
          message: '您确定要通过陪诊人吗？'
        }).then(() => {
          attendantAudit({ id: eCode, state:4 }).then(res => {
            this.$toast('审核成功')
            sendSms({ phone: phone, type: 'THE_COMPANION_WAS_APPROVED' ,data:{ signName: ""} }).then(res => {

            })
            this.arrEmployee = this.arrEmployee.filter(res => res.id != eCode)
          })
        }).catch(() => {
        })
      },

      //拒绝
      handlerClose: function (e) {
			  this.refuseReason = ''
			  this.refuseId = e.currentTarget.dataset.id
        this.name = e.currentTarget.dataset.name
        this.phone = e.currentTarget.dataset.phone
        this.flagModels = true
      },

      handlerSaveTask: function () {
			  if(this.refuseReason.length <= 0) {
          this.$toast('请输入拒绝原因')
          return;
        }
        attendantAudit({ id: this.refuseId, refuseReason: this.refuseReason, state: 3 }).then(res => {
          this.$toast('拒绝成功: 已拒绝'+this.name+'成为陪诊人')
          sendSms({ phone: this.phone, type: 'THE_COMPANION_REVIEW_WAS_NOT_APPROVED',data: { signName: "" } }).then(res => {

          })
          this.arrEmployee = this.arrEmployee.filter(res => res.id != this.refuseId)
          this.flagModels = false;
        })
      },

      initList: function () {
        console.log(this.preventRepeatRequest)
        if(this.preventRepeatRequest){
          this.preventRepeatRequest= false
          return;
        }
        this.preventRepeatRequest = true;
			  this.isLoading = true

        if(this.pages+ 1 == this.pageNumber && this.arrEmployee.length > 0) {
          this.isHadMore = false;
        }

        if(this.pages + 1 == this.pageNumber ) {
          return ;
        }
        //审陪诊人列表
        attendantList({pageNumber: this.pageNumber, pageSize: 10, state: 6 }).then(res => {
          this.preventRepeatRequest = true;
          this.isLoading = false;
          this.arrEmployee.push(...res.records)
          this.pageNumber++
          this.pages = res.pages
          this.preventRepeatRequest = false;
        })
      }
			
		},
		mounted: function(){
      this.pageNumber = 1
      this.arrEmployee = []
      this.isLoading = false
      this.isHadMore = true
      this.pageNumber = 1
      this.pages = 999
      this.flagModels = false
      this.refuseId = ''
      this.refuseReason = ''
      passportUserInfo().then(res => {
        this.initList();
      })
			// this.arrEmployee.push({ id: 1, name: '赵云', gender: 1, license: false, birth: '2022-12', mobile: '13233551255', address: '北京市·海淀区'})
			// this.arrEmployee.push({ id: 2, name: '曹操', gender: 1, license: false, birth: '2022-12', mobile: '13233551255', address: '北京市·海淀区'})
			// this.arrEmployee.push({ id: 3, name: '刘备', gender: 0, license: false, birth: '2022-12', mobile: '13233551255', address: '北京市·丰台区'})
			// this.arrEmployee.push({ id: 4, name: '关羽', gender: 1, license: false, birth: '2022-12', mobile: '13233551255', address: '北京市·朝阳区'})
			// this.arrEmployee.push({ id: 5, name: '张飞', gender: 0, license: false, birth: '2022-12', mobile: '13233551255', address: '北京市·通州区'})
			// this.arrEmployee.push({ id: 6, name: '姜维', gender: 1, license: false, birth: '2022-12', mobile: '13233551255', address: '北京市·大兴区'})
		}
	}
</script>

<style scoped>
.list{ padding: 0 0.2rem;}
.list>.item{ position: relative; background: #FFF; border-radius: 0.2rem; margin: 0.2rem 0 0; padding: 0 0.2rem 0.2rem;}
.list>.item>.text{ color: #333; height: 0.88rem; display: flex; justify-content: space-between; align-items: center;}
.list>.item>.text>.name{ font-size: 0.28rem; font-weight: 600; display: flex; justify-content: flex-start; align-items: center;}
.list>.item>.text>.name::before{ position: relative; content: ''; margin: 0 0.12rem 0 0; width: 0.36rem; height: 0.36rem; background-size: cover !important; background-position: 50% 50% !important;}
.list>.item>.text>.name-male::before{ background: url('~assets/images/icon-male.png');}
.list>.item>.text>.name-female::before{ background: url('~assets/images/icon-female.png');}
.list>.item>.info{ font-size: 0.28rem; padding: 0 0 0.1rem;}
.list>.item>.info>.row{ height: 0.4rem; line-height: 0.4rem; display: flex; justify-content: space-between; align-items: center;}
.list>.item>.info>.row>.lab{ color: #999;}
.list>.item>.info>.row>.inf{ color: #555;}
.list>.item>.link{ padding: 0.2rem 0 0; display: flex; justify-content: flex-end; align-items: center; position: relative;}
.list>.item>.link::after{ position: absolute; content: ''; left: 0; right: 0; top: 0; height: 1px; background: #e1e1e1;}
.list>.item>.link>.lnk-item{ height: 0.6rem; line-height: 0.6rem; padding: 0 0.24rem; margin: 0 0 0 0.16rem; border-radius: 0.12rem;}
.list>.item>.link>.lnk-ok{ background: #1890FF; border: 1px solid #1890FF; color: #FFF;}
.list>.item>.link>.lnk-no{ background: #ff4d4f; border: 1px solid #ff4d4f; color: #FFF;}
.list>.item>.link>.lnk-default{ background: #FFF; border: 1px solid #d9d9d9; color: #666;}
</style>